import { useEffect, useState, useCallback } from 'react';
import { useLoader } from '@/contexts/loader/LoaderContext';
import { useErrorHandling } from '@/utils/errorHandling';
import PaymentsAPIServiceV2, { Shift } from '@/services/PaymentsServiceV2';

export const useShifts = (userId: string, employeeType?: string) => {
    const { setLoading } = useLoader();
    const [shifts, setShifts] = useState<Shift[]>([]);
    const [totalHours, setTotalHours] = useState<number>(0);
    const [totalEarnings, setTotalEarnings] = useState<number>(0);
    const [shiftsError, setShiftsError] = useState<string>();

    const { backendErrorHandler } = useErrorHandling();

    const [isLoading, setIsLoading] = useState(false);

    const getShifts = useCallback(() => {
        setIsLoading(true);
        PaymentsAPIServiceV2.getInstance()
            .getUserShifts(userId)
            .then((response: any) => {
                setShifts(response.data.shifts);
                // debugger
                setTotalHours(response.data.totalHours);
                setTotalEarnings(response.data.totalAmount);
            })
            .catch(
                backendErrorHandler(undefined, (e, errorDetails) => {
                    setShiftsError(
                        'Error fetching shifts. ' + errorDetails?.detail
                    );
                })
            )
            .finally(() => {
                setIsLoading(false);
            });
    }, [backendErrorHandler, setLoading, userId, employeeType]);

    useEffect(() => {
        if (employeeType === 'Hourly') {
            getShifts();
        }
    }, [userId, employeeType]);

    return {
        shifts,
        totalHours,
        totalEarnings,
        shiftsError,
        isLoading
    } as const;
};
